module.exports = __webpack_public_path__ + "img/2.bfee6b8e.png";